/**
 * Created by intellicar-rinas on 8/9/17.
 */
import $http from '../helpers/$http';
import {API_HOST} from '../constants/constants';
import apiHelper, {processAssetList, processAssetInfo} from '../helpers/apiHelper';


const GeofenceAPIs = {

    getList: (body, uid) => {
        return $http.post(API_HOST + '/api/geofence/list',body, {}, uid)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
            .then(processGeofence, apiHelper.validateFailure);
    },

    getListWithPerm: (body, uid) => {
        return $http.post(API_HOST + '/api/geofence/listwitheditdeleteperm',body, {}, uid)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
            .then(processGeofence, apiHelper.validateFailure);
    },

    getInfo: (body, uid) => {
        return $http.post(API_HOST + '/api/geofence/getinfo',body, {}, uid)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
            .then(processAssetInfo, apiHelper.validateFailure)
    },

    getCreationInfo: (body, uid) => {
        return $http.post(API_HOST + '/api/geofence/getcreationinfo',body, {}, uid)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    },

    getMyGeofences: (body, uid) => {
        return $http.post(API_HOST + '/api/geofence/getmygeofences',body, {}, uid)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
            .then(processGeofence, apiHelper.validateFailure);
    },

    getMyGeofenceReports: (body, uid) => {
        return $http.post(API_HOST + '/api/geofencereport/getmygeofencereports',body, {}, uid)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
            .then(processGeofenceReport, apiHelper.validateFailure);
    },

    getLastEntryTime: (body, uid) => {
        return $http.post(API_HOST + '/api/geofencereport/getlastentrytime',body, {}, uid)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    },

    getReportHistory: (body, uid) => {
        return $http.post(API_HOST + '/api/geofencereport/reporthistory',body, {}, uid)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    },
    

};

const processGeofence = processAssetList("geofencename", "geofenceid", 'GEOFENCES');
const processGeofenceReport = processAssetList("fencename", "fenceid", 'GEOFENCES');

export default GeofenceAPIs;
